export const getBase64 = ({ originFileObj }) => {
  const data = new File([originFileObj], originFileObj.name, { type: originFileObj.type });
  return new Promise((resolve) => {
    var fileReader = new FileReader();
    fileReader.onloadend = (() => {
      return () => {
        resolve(fileReader.result);
      };
    })();
    fileReader.readAsDataURL(data);
  });
};
